import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '@reducers/interfaces';
import { clsx } from 'clsx';

import { selectAuthUserId } from '../../../reducers/auth/auth.selectors';
import { lazySelect } from '../../../shared/lazy-select.observable';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  selector: 'my-hours',
  template: `
    <employee-hours-overview
      [employeeId]="employeeId$ | async"
      [title]="'My timesheets' | translate"
    ></employee-hours-overview>
  `,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  host: { '[class]': 'hostClasses' },
})
export class MyHoursComponent {
  private store = inject<Store<AppState>>(Store);

  employeeId$ = this.store.pipe(lazySelect(selectAuthUserId));
  hostClasses = clsx('flex max-h-full min-h-0 flex-col px-5');
}
